import { useState } from "react";
import { FilterCategory } from "@/data/filterCategories";

interface MultiLevelFilterProps {
  title: string;
  categories: FilterCategory[];
  selectedFilters: string[];
  onFilterChange: (filter: string, isChecked: boolean) => void;
}

export default function MultiLevelFilter({
  title,
  categories,
  selectedFilters,
  onFilterChange
}: MultiLevelFilterProps) {
  const [expandedCategories, setExpandedCategories] = useState<number[]>([]);

  const toggleCategory = (id: number) => {
    setExpandedCategories(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="mb-6">
      <h3 className="font-bold text-lg mb-3">{title}</h3>
      <ul className="space-y-2">
        {categories.map(category => (
          <li key={category.id}>
            <div className="flex items-center">
              <button
                onClick={() => toggleCategory(category.id)}
                className="mr-2 text-gray-600 hover:text-[#1E90FF]"
              >
                <i className={`fa-solid fa-chevron-${expandedCategories.includes(category.id) ? 'down' : 'right'}`}></i>
              </button>
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedFilters.includes(category.name)}
                  onChange={(e) => onFilterChange(category.name, e.target.checked)}
                  className="rounded text-[#1E90FF]"
                />
                <span>{category.name}</span>
              </label>
            </div>
            {expandedCategories.includes(category.id) && category.children && (
              <ul className="ml-6 mt-2 space-y-2">
                {category.children.map(child => (
                  <li key={child.id} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={selectedFilters.includes(child.name)}
                      onChange={(e) => onFilterChange(child.name, e.target.checked)}
                      className="rounded text-[#1E90FF]"
                    />
                    <span>{child.name}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}